import { render } from "./AttendeeSegmentRaw.vue?vue&type=template&id=07c84936&scoped=true"
import script from "./AttendeeSegmentRaw.vue?vue&type=script&lang=js"
export * from "./AttendeeSegmentRaw.vue?vue&type=script&lang=js"

import "./AttendeeSegmentRaw.vue?vue&type=style&index=0&id=07c84936&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c84936"]])

export default __exports__